var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c("v-col", [
            _c("h1", [_vm._v(_vm._s(_vm.$t("processes.title")))]),
            _c("p", { staticClass: "subtitle-1 grey--text" }, [
              _vm._v(_vm._s(_vm.$t("processes.subtitle")))
            ])
          ])
        ],
        1
      ),
      _c(
        "v-row",
        [_c("v-col", { attrs: { cols: "12" } }, [_c("ProcessRunTable")], 1)],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }